import React from "react";
import { Navigate } from "react-router-dom";
import { usePermissoes } from "../contexts/PermissoesContext.tsx";

interface Props {
  children: React.ReactNode;
  /** Chave individual do usuário, das que o ADM liga uma a uma. */
  exige: "podeVerLog" | "podeExcluirAgendamento";
}

/**
 * Irmão do RoleRoute, para as permissões que NÃO vêm da função e sim da chave
 * individual do usuário.
 *
 * Conveniência de interface, não segurança: quem autoriza é o
 * FuncionalidadeInterceptor no backend. Serve para o usuário não esbarrar numa
 * tela que só lhe daria erro — sem isto, a rota digitada à mão renderizava a
 * casca da página presa em "carregando", porque a API respondia 403.
 */
const PermissaoRoute: React.FC<Props> = ({ children, exige }) => {
  const permissoes = usePermissoes();

  // Enquanto carrega não dá para decidir.
  if (permissoes.isLoading) return null;

  // Não deu para confirmar: deixa passar e o servidor barra, com mensagem
  // clara. Mesma regra do RoleRoute — gate de interface falha aberto.
  if (permissoes.erroAoCarregar) return <>{children}</>;

  if (!permissoes[exige]) return <Navigate to="/cirurgias" replace />;

  return <>{children}</>;
};

export default PermissaoRoute;
